import { Component, OnInit } from '@angular/core';
import { CoreService, PortalService } from 'src/app/services';
import { PlatForm, Tools } from 'src/app/models';
import { Helpers } from 'src/app/helpers';
@Component({
    selector: 'medpt-dashboard-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class DashboardLayoutComponent implements OnInit {
  isStudyStat:boolean =false;
  isRaiLayout: boolean = false;
  isRaspberryAI: boolean = (Helpers.getPlatformId() == PlatForm.RaspberryAI);
  constructor(
    private portalService: PortalService,
    private coreService: CoreService
  ) {
   
  }

  ngOnInit(): void {
    this.portalService.setPortalDisplayName("");
    this.portalService.setShowPortalSection(false);
    this.portalService.setIsRaiLayout(false);
    this.isStudyStat = (Helpers.getPlatformId() == PlatForm.StudyStat);
    this.coreService.getUserToolNavigation()
      .then((tools: Array<Tools>) => {
        this.portalService.setToolsMenuSubject(tools);
      }).catch((error: any) => {

      }).finally(() => {

      });
  }

}
